'use client';

import { Skeleton } from '@/components/ui/skeleton';

export function DetailPageGridSkeleton() {
  return (
    <div className="container py-6 space-y-6">
      <div className="flex items-center gap-4">
        <Skeleton className="h-9 w-9 rounded-md" />
        <div className="flex-1" />
        <Skeleton className="h-9 w-9 rounded-md" />
      </div>
      <div className="lg:hidden flex items-center gap-3">
        <Skeleton className="w-11 h-11 rounded-lg shrink-0" />
        <div className="flex-1 space-y-1.5">
          <Skeleton className="h-5 w-20" />
          <Skeleton className="h-3 w-32" />
        </div>
        <Skeleton className="h-8 w-16 rounded-md" />
      </div>
      <div className="lg:hidden grid grid-cols-2 gap-1.5">
        {[...Array(2)].map((_, i) => (
          <Skeleton key={i} className="h-12 rounded-md" />
        ))}
      </div>
      <div className="grid lg:grid-cols-[280px,1fr,280px] 2xl:grid-cols-[340px,1fr,340px] gap-6">
        <div className="hidden lg:block space-y-4">
          <div className="flex items-center gap-3">
            <Skeleton className="w-10 h-10 rounded-lg shrink-0" />
            <div className="flex-1 space-y-1.5">
              <Skeleton className="h-5 w-28" />
              <Skeleton className="h-3 w-20" />
            </div>
          </div>
          <Skeleton className="h-12 w-full rounded-lg" />
          <Skeleton className="h-12 w-full rounded-lg" />
        </div>
        <div className="border rounded-lg p-4">
          <div className="grid grid-cols-5 sm:grid-cols-10 gap-1">
            {[...Array(100)].map((_, i) => (
              <Skeleton key={i} className="aspect-square rounded-md" />
            ))}
          </div>
          <Skeleton className="h-4 w-48 mx-auto mt-3" />
        </div>
        <div className="hidden lg:block space-y-4">
          <Skeleton className="h-11 w-full rounded-md" />
          <Skeleton className="h-48 w-full rounded-lg" />
        </div>
      </div>
      <div className="lg:hidden">
        <Skeleton className="h-11 w-full rounded-md" />
      </div>
    </div>
  );
}
